import React from "react";
import { Box, Paper, Stack, Typography } from "@mui/material";
import { StratifyDocument } from "@stratify/shared";

interface FileInfoProps {
  document: StratifyDocument;
}

export const FileInfo: React.FC<FileInfoProps> = ({ document }) => {
  return (
    <Paper sx={{ p: 3 }}>
      <Typography variant="h6" gutterBottom>
        File Information
      </Typography>
      <Box sx={{ display: "flex", flexWrap: "wrap", gap: 2 }}>
        <Box sx={{ flex: { xs: "1 1 100%", sm: "1 1 calc(50% - 8px)" } }}>
          <Stack spacing={1}>
            <Typography variant="subtitle2" color="text.secondary">
              Name
            </Typography>
            <Typography data-testid="document-filename">
              {document.filename}
            </Typography>
          </Stack>
        </Box>
        <Box sx={{ flex: { xs: "1 1 100%", sm: "1 1 calc(50% - 8px)" } }}>
          <Stack spacing={1}>
            <Typography variant="subtitle2" color="text.secondary">
              Type
            </Typography>
            <Typography>{document.type}</Typography>
          </Stack>
        </Box>
        <Box sx={{ flex: { xs: "1 1 100%", sm: "1 1 calc(50% - 8px)" } }}>
          <Stack spacing={1}>
            <Typography variant="subtitle2" color="text.secondary">
              Size
            </Typography>
            <Typography>
              {(document.size / (1024 * 1024)).toFixed(2)} MB
            </Typography>
          </Stack>
        </Box>
        <Box sx={{ flex: { xs: "1 1 100%", sm: "1 1 calc(50% - 8px)" } }}>
          <Stack spacing={1}>
            <Typography variant="subtitle2" color="text.secondary">
              Uploaded
            </Typography>
            <Typography>
              {document.createdAt.toDate().toLocaleString()}
            </Typography>
          </Stack>
        </Box>
      </Box>
    </Paper>
  );
};
